import {Component, Input} from "@angular/core";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'vb-debug-content',
  templateUrl: './debug-content.component.html',
  styleUrls: ['./debug-content.component.css']
})
export class DebugContentComponent {

  @Input()
  enableDebug: boolean;

  constructor() {
    this.enableDebug = !environment.production;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/error-handling/debug-content/debug-content.component.ts